import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Circle from '../circle';
import PostThumbnail from '../postthumbnail';
import { posts } from '../../funcs/posts';
export default class First extends React.Component{
  render(){
    var self = this;
    var cs = ['page'];
    if(this.props.active == "first"){
      cs.push('active');
    }
    return(
      <div className={cs.join(' ')} id="first">
        <Circle dark animated/>

        <div className="page_container">
          {
            this.props.mainTitle ?
            <>
            <div className="page_h2">{this.props.mainTitle}</div>
            <a style={{marginTop: '1rem', marginLeft: '2rem', textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 600, display: 'inline-block', padding:'0.35rem 0.5rem', backgroundColor: '#f00143', color: 'white', marginBottom: '1rem'}} href={"https://www.animalpolitico.com/everyday-justice-mexico/"}>
              English version
            </a>
            </>
            : null
          }
          {
            !this.props.hideIntro ?
            <div id="interactivo_main_intro">
              <a style={{textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 600, display: 'inline-block', padding:'0.35rem 0.5rem', backgroundColor: '#f00143', color: 'white', marginBottom: '1rem'}} href="https://www.animalpolitico.com/everyday-justice-mexico/">
                English version
              </a><br/><br/>
              ¿Quién no se ha peleado con un vecino? Sea porque ocupa el lugar de estacionamiento que no le corresponde, porque hace mucho ruido o porque no pone la basura en su lugar.
              <br/><br/>
              ¿Quién no ha escuchado de los abusos de alguna expareja, que secuestró a sus hijos o que simplemente no paga pensión?
              <br/><br/>
              ¿Cuántos casos hay de trabajadores despedidos ilegalmente, que deben esperar años a que se resuelvan sus demandas?
              <br/><br/>
              ¿Y quién ha logrado que le hagan justicia?
              <br/><br/>
              En México, la mitad de la población ha sido víctima en casos parecidos.
              <br/><br/>
              Y el número de personas que lo ha resuelto, que ha obtenido justicia es una minoría: apenas el 10%.
            </div>
            : null
          }

          <div className="page_posts">
            <div className="page_posts_container">
              {
                posts.map(function(post){
                  return(
                    <PostThumbnail
                      title={post.title}
                      author={post.authors.join(',')}
                      img={post.featured}
                      date={post.date}
                      video={post.video}
                      slug={post.slug}
                      premiumUntil={post.premiumUntil}
                      {...self.props}
                    />
                  )
                })
              }

            </div>
          </div>
        </div>
      </div>
    )
  }
}
